(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lpc-featured-product-home"] && !Shopify.designMode) return;
  try {
    
  function initializeLpcFeatured(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const variantsElement = root.querySelector('[data-product-variants]');
    const configElement = root.querySelector('[data-featured-config]');
    if (!variantsElement || !configElement) return;

    const variants = JSON.parse(variantsElement.textContent);
    const config = JSON.parse(configElement.textContent);
    const groups = Array.from(root.querySelectorAll('[data-option-index]'));
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-current-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const mainImage = root.querySelector('.lpc-featured__main-image');
    const thumbnails = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const thumbnailList = root.querySelector('[data-thumb-list]');
    const form = root.querySelector('.lpc-featured__form');
    const locale = document.documentElement.lang || 'fr-BE';
    const currency = variants[0]?.price ? 'EUR' : 'EUR';
    let activeMediaIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));

    function selectedValues() {
      return groups.map((group) => group.querySelector('.is-selected')?.dataset.optionValue || '');
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    }

    function displayMedia(index, shouldScroll = true) {
      if (!mainImage || !thumbnails.length) return;
      activeMediaIndex = (index + thumbnails.length) % thumbnails.length;
      const selectedThumbnail = thumbnails[activeMediaIndex];

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = selectedThumbnail.dataset.imageSrc;
      mainImage.alt = selectedThumbnail.dataset.imageAlt || '';

      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const isActive = thumbnailIndex === activeMediaIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (shouldScroll && thumbnailList) {
        const isHorizontal = window.getComputedStyle(thumbnailList).flexDirection === 'row';
        const scrollOptions = { behavior: 'smooth' };
        if (isHorizontal) {
          scrollOptions.left = Math.max(0, selectedThumbnail.offsetLeft - (thumbnailList.clientWidth - selectedThumbnail.offsetWidth) / 2);
        } else {
          scrollOptions.top = Math.max(0, selectedThumbnail.offsetTop - (thumbnailList.clientHeight - selectedThumbnail.offsetHeight) / 2);
        }
        thumbnailList.scrollTo(scrollOptions);
      }
    }

    function displayVariantMedia(variant) {
      const mediaId = variant.featured_media?.id;
      const variantImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
      const matchingIndex = thumbnails.findIndex((thumbnail) => {
        if (mediaId && thumbnail.dataset.imageId === String(mediaId)) return true;
        if (!variantImage) return false;
        return thumbnail.dataset.imageSrc?.split('?')[0] === variantImage.split('?')[0];
      });

      if (matchingIndex >= 0) {
        displayMedia(matchingIndex);
      } else if (mainImage && variantImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = variantImage;
        mainImage.alt = variant.featured_image?.alt || variant.featured_media?.alt || '';
      }
    }

    function refreshFrom(startIndex) {
      let selected = selectedValues();

      for (let index = startIndex; index < groups.length; index += 1) {
        const group = groups[index];
        const buttons = Array.from(group.querySelectorAll('[data-option-value]'));
        buttons.forEach((button) => {
          const possible = variants.some((variant) => {
            if (!variant.available || variant.options[index] !== button.dataset.optionValue) return false;
            return selected.slice(0, index).every((value, optionIndex) => variant.options[optionIndex] === value);
          });
          const autumn = root.classList.contains('lpc-featured--autumn');
          button.hidden = autumn ? false : !possible;
          button.disabled = autumn && !possible;
          button.classList.toggle('is-unavailable', autumn && !possible);
        });

        const current = group.querySelector('.is-selected:not([hidden]):not(:disabled)');
        const next = current || buttons.find((button) => !button.hidden && !button.disabled);
        buttons.forEach((button) => {
          const active = button === next;
          button.classList.toggle('is-selected', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        group.querySelector('[data-option-label]').textContent = next?.dataset.optionValue || '';
        selected = selectedValues();
      }

      const stockNote = root.querySelector('[data-stock-note]');
      if (stockNote) stockNote.hidden = !groups.some(group => group.querySelector('.is-unavailable:not(.lpc-featured__value--swatch)'));
      const variant = variants.find((item) => item.available && item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = config.unavailableLabel;
        return;
      }

      variantInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = formatMoney(variant.compare_at_price);
        comparePrice.hidden = false;
      } else {
        comparePrice.hidden = true;
      }
      addButton.disabled = false;
      addLabel.textContent = config.availableLabel;

      displayVariantMedia(variant);
    }

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => displayMedia(index));
    });

    root.querySelectorAll('[data-gallery-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const increment = button.dataset.galleryStep === 'next' ? 1 : -1;
        displayMedia(activeMediaIndex + increment);
      });
    });

    root.querySelectorAll('[data-thumb-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!thumbnailList) return;
        const increment = button.dataset.thumbScroll === 'next' ? 1 : -1;
        const isHorizontal = window.getComputedStyle(thumbnailList).flexDirection === 'row';
        thumbnailList.scrollBy({
          left: isHorizontal ? increment * 220 : 0,
          top: isHorizontal ? 0 : increment * 260,
          behavior: 'smooth'
        });
      });
    });

    groups.forEach((group, groupIndex) => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button || button.hidden || button.disabled) return;
        group.querySelectorAll('[data-option-value]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        group.querySelector('[data-option-label]').textContent = button.dataset.optionValue;
        refreshFrom(groupIndex + 1);
      });
    });

    form?.addEventListener('submit', () => {
      const drawer = document.querySelector('cart-drawer-component');
      const themeDrawer = drawer?.closest('theme-drawer');
      drawer?.setAttribute('auto-open', '');
      window.setTimeout(() => themeDrawer?.open?.(), 250);
    });

    refreshFrom(0);
  }

  document.querySelectorAll('[data-lpc-featured]').forEach(initializeLpcFeatured);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-lpc-featured]');
    if (section) initializeLpcFeatured(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpc-product-also"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lpc-also-carousel')){
customElements.define('lpc-also-carousel',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.lpc-also__track');
this.buttons=[...this.querySelectorAll('button[data-direction]')];
this.abort=new AbortController();
const signal=this.abort.signal;
this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.buttons[0].disabled=this.track.scrollLeft<2;this.buttons[1].disabled=this.track.scrollLeft>=max-2;};
this.buttons.forEach(button=>button.addEventListener('click',()=>{
const card=this.track.querySelector('li');if(!card)return;
const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
this.track.scrollBy({left:Number(button.dataset.direction)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
},{signal}));
this.track.addEventListener('scroll',this.update,{passive:true,signal});
this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
